import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getExpiryStatus(expirationDate) {
  if (!expirationDate) return { status: 'unknown', daysUntil: null };
  
  const now = new Date();
  const expiry = new Date(expirationDate);
  const daysUntil = Math.ceil((expiry - now) / (1000 * 60 * 60 * 24));
  
  if (daysUntil < 0) {
    return { status: 'expired', daysUntil };
  } else if (daysUntil <= 7) {
    return { status: 'critical', daysUntil };
  } else if (daysUntil <= 30) {
    return { status: 'warning', daysUntil };
  } else {
    return { status: 'safe', daysUntil };
  }
}

export function formatDate(date) {
  if (!date) return 'N/A';
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}